import { render, staticRenderFns } from "./GameCardButton.vue?vue&type=template&id=300cd824&"
import script from "./GameCardButton.vue?vue&type=script&lang=js&"
export * from "./GameCardButton.vue?vue&type=script&lang=js&"
import style0 from "./GameCardButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VFlex,VProgressCircular})


/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('300cd824')) {
      api.createRecord('300cd824', component.options)
    } else {
      api.reload('300cd824', component.options)
    }
    module.hot.accept("./GameCardButton.vue?vue&type=template&id=300cd824&", function () {
      api.rerender('300cd824', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GameCardButton.vue"
export default component.exports